import { PredefinitionPropertyHandler } from '@ingka/webc-tools';
const DEFAULT_TASK_ID = '__skapa_default_task';
export default class SkapaElement extends HTMLElement {
    constructor() {
        super(...arguments);
        this.tasks = new Map();
        this.__updateTaskID = -1;
        this.gatherProperties = PredefinitionPropertyHandler.gatherProperties;
        this.initGatheredProperties = PredefinitionPropertyHandler.initGatheredProperties;
        this.micro = (task, taskName = DEFAULT_TASK_ID, delay) => {
            if (typeof window !== 'undefined') {
                clearTimeout(this.tasks.get(taskName));
                this.tasks.set(taskName, window.setTimeout(task, delay));
            }
        };
    }
    connectedCallback() {
        this.initGatheredProperties(this);
    }
    disconnectedCallback() {
        if (typeof window !== 'undefined') {
            this.tasks.forEach(taskID => window.clearTimeout(taskID));
            this.tasks.clear();
        }
    }
}
